import { useState } from 'react';
import { Reveal } from './Reveal.tsx';
import { getIcon } from '../../lib/icons.ts';
import type { SiteConfig, StepItem } from '../../siteContentTypes.ts';

export function HowItWorks({ config }: { config: SiteConfig }) {
  const [tab, setTab] = useState<'extra' | 'resto'>('extra');
  const steps: StepItem[] = (tab === 'extra' ? config.howItWorks.extraSteps : config.howItWorks.restoSteps)
    .filter((s) => s.visible)
    .sort((a, b) => a.order - b.order);

  return (
    <section id="comment-ca-marche" style={{ padding: '56px 24px', maxWidth: 1160, margin: '0 auto' }}>
      <Reveal>
        <h2 style={{ textAlign: 'center', fontSize: 30, fontWeight: 800, marginBottom: 24 }}>{config.howItWorks.title}</h2>

        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 36 }}>
          <div style={{ display: 'inline-flex', gap: 4, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 999, padding: 4 }}>
            {(['extra', 'resto'] as const).map((key) => (
              <button
                key={key}
                type="button"
                onClick={() => setTab(key)}
                style={{
                  border: 'none',
                  cursor: 'pointer',
                  padding: '9px 20px',
                  borderRadius: 999,
                  fontSize: 13.5,
                  fontWeight: 700,
                  background: tab === key ? 'var(--accent)' : 'transparent',
                  color: tab === key ? '#fff' : 'var(--text-secondary)',
                }}
              >
                {key === 'extra' ? 'Pour les extras' : 'Pour les restaurateurs'}
              </button>
            ))}
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 18 }}>
          {steps.map((step) => {
            const Icon = getIcon(step.icon);
            return (
              <Reveal key={step.title} delay={step.number * 0.05}>
                <div className="card" style={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 10 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div
                      style={{
                        width: 32,
                        height: 32,
                        borderRadius: '50%',
                        background: 'var(--accent)',
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 13,
                        fontWeight: 800,
                      }}
                    >
                      {step.number}
                    </div>
                    <Icon size={18} color="var(--accent-dark)" />
                  </div>
                  <div style={{ fontWeight: 800, fontSize: 14.5 }}>{step.title}</div>
                  <div style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.5 }}>{step.description}</div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Reveal>
    </section>
  );
}
